var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 615.81023,
    height: 496.34176,
    viewBox: "0 0 615.81023 496.34176",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M324.64754,460.43514c-53.30136,0-103.59888-16.74805-145.45451-48.43457l1.27675-1.57422c41.48818,31.40723,91.34394,48.00879,144.17776,48.00879,52.87527,0,102.76187-16.625,144.26773-48.07715l1.27776,1.57422c-41.87383,31.73047-92.20268,48.50293-145.54549,48.50293Z",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M561.55135,392.51577c2.06592,.12937,3.20768-2.43737,1.64468-3.93333l-.1555-.61819c.02047-.04951,.04105-.09897,.06178-.14839,2.08924-4.9818,9.16992-4.94742,11.24139,.04177,1.83859,4.42817,4.17942,8.86389,4.75579,13.54594,.25838,2.0668,.14213,4.17236-.31648,6.20047,4.30807-9.41059,6.57515-19.68661,6.57515-30.02077,0-2.59652-.14213-5.19301-.43275-7.78295-.239-2.11854-.56839-4.2241-.99471-6.31034-2.30575-11.2772-7.29852-22.01825-14.50012-30.98962-3.46197-1.89248-6.34906-4.85065-8.09295-8.39652-.62649-1.27891-1.11739-2.65462-1.34991-4.05618,.39398,.05168,1.48556-5.94866,1.18841-6.3168,.54906-.83317,1.53178-1.24733,2.13144-2.06034,2.98232-4.04341,7.0912-3.33741,9.23621,2.15727,4.58224,2.31266,4.62659,6.14806,1.81495,9.83683-1.78878,2.34682-2.03456,5.52233-3.60408,8.03478,.16151,.20671,.32944,.40695,.4909,.61366,2.96106,3.79788,5.52208,7.88002,7.68104,12.16859-.61017-4.76621,.29067-10.50822,1.82641-14.20959,1.74819-4.21732,5.02491-7.76915,7.91045-11.41501,3.46601-4.37924,10.57337-2.46806,11.18401,3.08332,.00591,.05375,.01166,.10745,.01731,.1612-.4286,.24178-.84849,.49867-1.25864,.76992-2.33949,1.54723-1.53096,5.17386,1.24107,5.60174l.06277,.00967c-.15503,1.54366-.41984,3.07444-.80734,4.57937,3.70179,14.31579-4.29011,19.5299-15.70147,19.76412-.25191,.12916-.49738,.25832-.74929,.38109,1.15617,3.25525,2.07982,6.59447,2.76441,9.97891,.61359,2.99043,1.03991,6.01317,1.27885,9.04888,.29715,3.83006,.27129,7.67959-.05168,11.50323l.01939-.13562c.82024-4.21115,3.10671-8.14462,6.4266-10.87028,4.94561-4.06264,11.93282-5.55869,17.26826-8.82425,2.56833-1.57196,5.85945,.45945,5.41121,3.43708l-.02182,.14261c-.79443,.32289-1.56947,.69755-2.31871,1.11733-.4286,.24184-.84848,.49867-1.25864,.76992-2.33949,1.54729-1.53096,5.17392,1.24107,5.6018l.06282,.00965c.0452,.00646,.08397,.01295,.12911,.01944-1.36282,3.23581-3.26168,6.23922-5.63854,8.82922-2.31463,12.49713-12.25603,13.68282-22.89022,10.04354h-.00648c-1.16259,5.06378-2.86128,10.01127-5.0444,14.72621h-18.02019c-.06463-.20022-.12274-.40692-.18089-.60717,1.6664,.10341,3.34571,.00649,4.98629-.29702-1.33701-1.64059-2.67396-3.29409-4.01097-4.93462-.03229-.0323-.05816-.0646-.08397-.09689-.67817-.8396-1.36282-1.67283-2.04099-2.51246l-.00036-.00102c-.04245-2.57755,.26652-5.14662,.87876-7.63984l.00057-.00035Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2995,392.51577c-2.06592,.12937-3.20768-2.43737-1.64468-3.93333l.1555-.61819c-.02047-.04951-.04105-.09897-.06178-.14839-2.08924-4.9818-9.16992-4.94742-11.24139,.04177-1.83859,4.42817-4.17942,8.86389-4.75579,13.54594-.25838,2.0668-.14213,4.17236,.31648,6.20047-4.30807-9.41059-6.57515-19.68661-6.57515-30.02077,0-2.59652,.14213-5.19301,.43275-7.78295,.239-2.11854,.56839-4.2241,.99471-6.31034,2.30575-11.2772,7.29852-22.01825,14.50012-30.98962,3.46197-1.89248,6.34906-4.85065,8.09295-8.39652,.62649-1.27891,1.11739-2.65462,1.34991-4.05618-.39398,.05168-1.48556-5.94866-1.18841-6.3168-.54906-.83317-1.53178-1.24733-2.13144-2.06034-2.98232-4.04341-7.0912-3.33741-9.23621,2.15727-4.58224,2.31266-4.62659,6.14806-1.81495,9.83683,1.78878,2.34682,2.03456,5.52233,3.60408,8.03478-.16151,.20671-.32944,.40695-.4909,.61366-2.96106,3.79788-5.52208,7.88002-7.68104,12.16859,.61017-4.76621-.29067-10.50822-1.82641-14.20959-1.74819-4.21732-5.02491-7.76915-7.91045-11.41501-3.46601-4.37924-10.57337-2.46806-11.18401,3.08332-.00591,.05375-.01166,.10745-.01731,.1612,.4286,.24178,.84849,.49867,1.25864,.76992,2.33949,1.54723,1.53096,5.17386-1.24107,5.60174l-.06277,.00967c.15503,1.54366,.41984,3.07444,.80734,4.57937-3.70179,14.31579,4.29011,19.5299,15.70147,19.76412,.25191,.12916,.49738,.25832,.74929,.38109-1.15617,3.25525-2.07982,6.59447-2.76441,9.97891-.61359,2.99043-1.03991,6.01317-1.27885,9.04888-.29715,3.83006-.27129,7.67959,.05168,11.50323l-.01939-.13562c-.82024-4.21115-3.10671-8.14462-6.4266-10.87028-4.94561-4.06264-11.93282-5.55869-17.26826-8.82425-2.56833-1.57196-5.85945,.45945-5.41121,3.43708l.02182,.14261c.79443,.32289,1.56947,.69755,2.31871,1.11733,.4286,.24184,.84848,.49867,1.25864,.76992,2.33949,1.54729,1.53096,5.17392-1.24107,5.6018l-.06282,.00965c-.0452,.00646-.08397,.01295-.12911,.01944,1.36282,3.23581,3.26168,6.23922,5.63854,8.82922,2.31463,12.49713,12.25603,13.68282,22.89022,10.04354h.00648c1.16259,5.06378,2.86128,10.01127,5.0444,14.72621h18.02019c.06463-.20022,.12274-.40692,.18089-.60717-1.6664,.10341-3.34571,.00649-4.98629-.29702,1.33701-1.64059,2.67396-3.29409,4.01097-4.93462,.03229-.0323,.05816-.0646,.08397-.09689,.67817-.8396,1.36282-1.67283,2.04099-2.51246l.00036-.00102c.04245-2.57755-.26652-5.14662-.87876-7.63984l-.00057-.00035Z",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.66481,411.12457l-.84046,.98528c-32.8209-27.9919-51.64491-68.76902-51.64491-111.8759,0-39.26632,15.29047-76.18137,43.05439-103.94561,27.76424-27.76392,64.67929-43.05439,103.94561-43.05439s76.18137,15.29047,103.94561,43.05439c27.76392,27.76424,43.05439,64.67929,43.05439,103.94561,0,43.10688-18.824,83.884-51.64491,111.8759l-.84046-.98528",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.42846,410.55227l-1.29785-1.52148c50.23682-42.84473,79.04883-105.25977,79.04883-171.23926,0-124.06543-100.93457-225-225-225S100.17944,113.72609,100.17944,237.79152c0,65.97949,28.81201,128.39453,79.04883,171.23926l-1.29785,1.52148c-50.68262-43.22559-79.75098-106.19434-79.75098-172.76074,0-60.63574,23.61182-117.64062,66.48535-160.51465C207.53882,34.40334,264.5437,10.79152,325.17944,10.79152s117.64062,23.61182,160.51465,66.48535c42.87354,42.87402,66.48535,99.87891,66.48535,160.51465,0,66.56641-29.06836,129.53516-79.75098,172.76074Z",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395,410.15176c0,.66003,.53003,1.19,1.19006,1.19h218.28998c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19h-218.28998c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.17944,
    y: 11.79152,
    width: 2,
    height: 69.40186,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.47876,
    y: 234.4927,
    width: 69.40137,
    height: 2,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.17929,
    y: 59.79182,
    width: 2.00031,
    height: 69.40126,
    transform: "translate(-15.10394 146.5896) rotate(-39.21836)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.47831,
    y: 349.49243,
    width: 69.40225,
    height: 1.99955,
    transform: "translate(-183.31398 186.63791) rotate(-39.23231)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 480.47876,
    y: 234.4927,
    width: 69.40137,
    height: 2,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 417.47881,
    y: 93.4923,
    width: 69.40126,
    height: 2.00031,
    transform: "translate(93.08822 385.09281) rotate(-50.78538)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 479.17967,
    y: 315.79108,
    width: 1.99955,
    height: 69.40225,
    transform: "translate(-94.96923 500.89529) rotate(-50.78127)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 325.17944,
    cy: 230.79152,
    r: 28,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 454.17944,
    cy: 327.79152,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 476.17944,
    cy: 237.79152,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 428.17944,
    cy: 121.79152,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324.17944,
    cy: 83.79152,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 221.17944,
    cy: 121.79152,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.17944,
    cy: 234.79152,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 198.17944,
    cy: 326.79152,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 270.2406,
    cy: 232.83384,
    r: 10,
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.43272,
    y: 220.3559,
    width: 238,
    height: 14,
    rx: 6.99999,
    ry: 6.99999,
    transform: "translate(-9.42125 16.96564) rotate(-2.46588)",
    fill: "#02a7b6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "402.06744 487.72083 390.40451 487.71968 384.85639 442.73359 402.06981 442.73477 402.06744 487.72083",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1088,487.45625h0c-.36312,.61157-.55475,2.58554-.55475,3.29679h0c0,2.18618,1.77224,3.95842,3.95841,3.95842h36.11873c1.49141,0,2.70044-1.20903,2.70044-2.70044v-1.50374s1.78678-4.5195-1.89188-10.09004c0,0-4.57205,4.36184-11.40385-2.46996l-2.01463-3.64964-14.58321,10.66537-8.08325,.99497c-1.76842,.21768-3.33634-.03379-4.246,1.49828Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "463.4814 487.72083 451.81847 487.71968 446.27035 442.73359 463.48378 442.73477 463.4814 487.72083",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.52277,487.45625h0c-.36312,.61157-.55475,2.58554-.55475,3.29679h0c0,2.18618,1.77224,3.95842,3.95841,3.95842h36.11873c1.49141,0,2.70044-1.20903,2.70044-2.70044v-1.50374s1.78678-4.5195-1.89188-10.09004c0,0-4.57205,4.36184-11.40385-2.46996l-2.01463-3.64964-14.58321,10.66537-8.08325,.99497c-1.76842,.21768-3.33634-.03379-4.246,1.49828Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "490.59375 125.59096 491.82822 178.42488 480.39329 225.97719 469.74736 222.43943 472.8483 179.12023 470.12028 120.74886 490.59375 125.59096",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 473.29779,
    cy: 232.50842,
    rx: 12.46646,
    ry: 7.40196,
    transform: "translate(175.32063 667.57229) rotate(-81.75525)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.68043,77.79459s19.6212-.04457,22.93474,11.45262c3.44537,11.95459,8.94147,56.54175,6.56427,56.54431l-24.49678,3.09609-5.00223-71.09302Z",
    fill: "#02a7b6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "387.85382 131.22174 377.04162 182.95223 355.09297 226.65848 345.53042 220.79255 358.40082 179.31337 375.01781 121.85088 387.85382 131.22174",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 346.69816,
    cy: 231.40511,
    rx: 12.46646,
    ry: 7.40196,
    transform: "translate(4.79208 469.83365) rotate(-68.61132)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.3572,79.9219s10.72949,4.78494,13.72961,16.36786c2.72899,10.53624,9.4767,56.90111-10.34875,54.72461l-25-2c-.17749-24.60782,10.44592-47.80939,21.61914-69.09247Z",
    fill: "#02a7b6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M381.17944,230.79152l-4,36,2,101.15748,4,94.84252h21.15748l23.84252-173,15.46457,173h24.56693l6.9685-117s5-109-4-118-90,3-90,3Z",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.67944,59.29152h-32.75984l-7.24016,10s-14,2-23,11l-1,96-6.5,62.77559,97.99213-2.77559-5.99213-34.5,3.99213-121.08661s-10.49213-12.41339-17.49213-10.41339l-8-11Z",
    fill: "#02a7b6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.98496,
    cy: 29.43287,
    r: 24.51203,
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.04408,6.6077c-2.74206-2.41502-6.50558-3.8053-10.09628-3.5589-2.17629,.14934-4.29025-.53512-6.22218-1.54811-.13079-.06858-.26435-.13102-.39973-.18697-1.21846-.50344-2.57215-.55985-3.89016-.52791-2.40222,.05825-5.24269-2.35068-7.1234,.99007-7.11929-1.34074-7.77645,2.79638-11.08955,5.23427-.93863-.55372-7.01061,.45501-7.64972,1.45128-.4867,.75869-.82503,1.53165-1.05412,2.28222-.14695,.48147,.74148,2.23811,.6741,2.69148s-1.09058-.39651-1.09904,.00943c-.02266,1.08661,.12876,1.96862,.25613,2.46052,.32518,1.25545-3.00822-.35294-4.1022,.34371-1.09395,.69671,.02135,3.92015-1.04853,4.65322-1.27653,.87459-.43124,1.84131,.68136,2.98442,.76679,.78781,1.66054,1.65939,2.07422,2.64231,1.01388,2.40925-4.55709,4.54409-1.99327,4.03501,2.64623-.52542,3.509,3.5932,5.73539,2.06952,5.03659-3.44685,4.85454-3.16402,9.25037,1.06975,1.22055,1.1756,3.618-3.42816,5.23198-2.91151,3.04125,.97362,5.52594,4.23654,7.53389,9.16891,.28416,.69802-2.41008,12.08769-2.53389,12.83109-.28844,1.73188,7.77557-2.17608,7.7541-.28698-.02837,2.49297,4.40323-.6495,5.67868,1.53554,.16025-.19913,9.14997-4.28742,9.58081-4.60494l6.22865-6.02053c4.08306-6.98734,5.64212-15.41451,4.32908-23.40014-.82699-5.02954-2.8816-10.03798-6.70668-13.40676Z",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M324,495.15176c0,.66003,.53003,1.19,1.19006,1.19h218.28998c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19h-218.28998c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,410.15176c0,.66003,.53003,1.19,1.19006,1.19H219.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z",
    fill: "#ccc"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.6e6e685457b5bb3137b8ceb3f23ec169.svg";
export { ForwardRef as ReactComponent };